import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css"; // or "./index.css", whatever your file is
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary, { CHUNK_RELOAD_KEY } from "./components/ErrorBoundary";
import { initErrorReporter } from "./services/errorReporter";
import { API_CONFIG } from "./constants/app";

// Initialise error reporting before rendering so window.onerror is registered
// immediately.  No-op when VITE_SENTRY_DSN is not set.
initErrorReporter({
  release:     process.env['VITE_VERSION'],
  environment: process.env['NODE_ENV'] as 'development' | 'production' | 'test' | undefined,
});

// Initialise the clinical ML service after first paint. It is not needed for
// public landing content, so keep its model/cache code out of the render path.
const configureClinicalML = () => {
  void import("./services/clinicalMLService").then(({ ClinicalMLService }) => {
    ClinicalMLService.getInstance().configure({
      apiBaseUrl:           API_CONFIG.BASE_URL,
      weightSyncIntervalMs: 24 * 60 * 60 * 1000,  // re-sync weights every 24 h
    });
  });
};

if (window.requestIdleCallback) {
  window.requestIdleCallback(configureClinicalML, { timeout: 5000 });
} else {
  window.setTimeout(configureClinicalML, 2500);
}

// A deploy replaced the lazy page files while this tab still runs the old
// version: Vite reports the failed preload here. Reload once to fetch the
// current version (progress is saved); a repeat falls through to
// ErrorBoundary's manual-recovery screen, which shares the same one-shot key.
window.addEventListener("vite:preloadError", (event) => {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
  event.preventDefault();
  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  window.location.reload();
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
